<!-- This File shows the account details for a Seller -->
<template>
  <div class="account">
     <h1 class=" text-xs-left">
       <img src="../../../static/images/icon8icons/icons8-settings-50-2.png" />
       Account
     </h1>

     <div class="ml-4 mr-1 text-xs-left" >
       <br /><br />

       <!-- Next payment and update credit card -->
       <CreditCard v-if="stripeReady"></CreditCard>
       <div v-else>
         Loading credit card info...<v-progress-circular></v-progress-circular>
       </div>

      <!-- Subscription Type may need to check stripeReady here. -->
      <SubscriptionCard v-if="subscriptionStatus==='active' || subscriptionStatus==='trialing' || subscriptionStatus==='demo'"></SubscriptionCard>
      <SubscriptionCardCancel v-if="subscriptionStatus==='canceled'"></SubscriptionCardCancel>


      <!-- Parent -->
      <ParentCard v-if="parentUID"></ParentCard>
      <ParentCardCreate v-else></ParentCardCreate>

      <!-- Email -->
      <EmailCardLink></EmailCardLink>

      <hr />
      <ReturnToDashboard></ReturnToDashboard>
    </div>
</div>

</template>

<script>

import {mapState} from 'vuex'
import ParentCard from './account/ParentCard'
import SubscriptionCard from './account/SubscriptionCard'
import SubscriptionCardCancel from './account/SubscriptionCardCancel'
import CreditCard from './account/CreditCard'
import EmailCardLink from './account/EmailCardLink'
import ParentCardCreate from './account/ParentCardCreate'
import ReturnToDashboard from './ReturnToDashboard'
import utils from '../../utils.ts'

export default {
  name: 'Account',
  components: {
    ParentCard,
    SubscriptionCard,
    SubscriptionCardCancel,
    CreditCard,
    EmailCardLink,
    ParentCardCreate,
    ReturnToDashboard
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      subscriptionStatus: state => state.admin.data_ro.subscriptionStatus,
      parentUID: state => state.admin.data_ro.parentUID, // If present
      stripeReady: state => state.shopping.stripeReady
    })

  },
  mounted: function () {
    // Dynamically load stripeScript if not loaded.
    utils.loadStripe()
  },
  props: {

  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
